import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SurveysState } from '../reducers/surveys.reducer';

export const selectSurveysState = createFeatureSelector<SurveysState>('surveys');

export const selectSurveyList = createSelector(selectSurveysState, state => state.collection);

export const selectPending = createSelector(selectSurveysState, state => state.pending > 0);

export const selectLoading = createSelector(selectSurveysState, state => state.loading > 0);
